const i18nText: any = {
    en: {
        search_delete: 'Delete',
        site_nav_search: 'Search Ecoflow.com',
        site_nav_search_recommend: 'Recommendations',
        site_nav_search_recommend_bundle: 'Recommend Bundles',
        search_empty: 'No content～',
        hot_search: 'Hot Search',
        search_history: 'Search History',
        suggested_product: 'Suggested Product',
        suggested_search: 'Suggested Search',
    },
    de: {
        search_delete: 'Löschen',
        site_nav_search: 'EcoFlow.com durchsuchen',
        site_nav_search_recommend: 'Empfehlungen',
        site_nav_search_recommend_bundle: 'Empfohlene Bundles',
        search_empty: 'Kein Inhalt～',
        hot_search: 'Beliebte Suchanfragen',
        search_history: 'Suchverlauf',
        suggested_product: 'Produktempfehlungen',
        suggested_search: 'Suchvorschläge',
    },
    fr: {
        search_delete: 'Supprimer',
        site_nav_search: 'Rechercher sur EcoFlow.com',
        site_nav_search_recommend: 'Recommandations',
        site_nav_search_recommend_bundle: 'Lots recommandés',
        search_empty: 'Aucun contenu～',
        hot_search: 'Recherches populaires',
        search_history: 'Historique des recherches',
        suggested_product: 'Produits recommandés',
        suggested_search: 'Suggestions de recherche',
    },
    it: {
        search_delete: 'Elimina',
        site_nav_search: 'Cerca su EcoFlow.com',
        site_nav_search_recommend: 'Raccomandazioni',
        site_nav_search_recommend_bundle: 'Bundle consigliati',
        search_empty: 'Nessun contenuto～',
        hot_search: 'Ricerche popolari',
        search_history: 'Cronologia delle ricerche',
        suggested_product: 'Prodotti consigliati',
        suggested_search: 'Suggerimenti di ricerca',
    },
    es: {
        search_delete: 'Eliminar',
        site_nav_search: 'Cerca su EcoFlow.com',
        site_nav_search_recommend: 'Recomendaciones',
        site_nav_search_recommend_bundle: 'Paquetes recomendados',
        search_empty: 'Sin contenido～',
        hot_search: 'Búsquedas populares',
        search_history: 'Historial de búsqueda',
        suggested_product: 'Productos recomendados',
        suggested_search: 'Sugerencias de búsqueda',
    },
    kr: {
        search_delete: 'Delete',
        site_nav_search: '검색하기 Ecoflow.com',
        site_nav_search_recommend: '추천 검색어',
        site_nav_search_recommend_bundle: '추천 상품 묶음',
        search_empty: '콘텐츠 없음',
        hot_search: '인기 검색어',
        search_history: '검색 기록',
        suggested_product: '추천 제품',
        suggested_search: '추천 검색어',
    },
    jp: {
        search_delete: '削除',
        site_nav_search: '製品名などを入力してください',
        site_nav_search_recommend: 'おすすめ',
        site_nav_search_recommend_bundle: 'おすすめセット',
        search_empty: 'コンテンツなし',
        hot_search: '人気の検索',
        search_history: '検索履歴',
        suggested_product: 'おすすめ製品',
        suggested_search: '検索候補',
    },
    br: {
        search_delete: 'Excluir',
        site_nav_search: 'Pesquisar Ecoflow.com',
        site_nav_search_recommend: 'Recomendações',
        site_nav_search_recommend_bundle: 'Combos recomendados',
        search_empty: 'Nenhum conteúdo～',
        hot_search: 'Buscas em alta',
        search_history: 'Histórico de busca',
        suggested_product: 'Produtos recomendados',
        suggested_search: 'Sugestões de pesquisa',
    },
    mx: {
        search_delete: 'Borrar',
        site_nav_search: 'Buscar en Ecoflow.com',
        site_nav_search_recommend: 'Recomendaciones',
        site_nav_search_recommend_bundle: 'Paquetes recomendados',
        search_empty: 'Sin contenido～',
        hot_search: 'Búsquedas populares',
        search_history: 'Historial de búsqueda',
        suggested_product: 'Productos recomendados',
        suggested_search: 'Sugerencias de búsqueda',
    },
    sa: {
        search_delete: 'حذف',
        site_nav_search: 'البحث في Ecoflow.com',
        site_nav_search_recommend: 'توصيات',
        site_nav_search_recommend_bundle: 'توصيات الحزم',
        search_empty: 'لا يوجد محتوى～',
        hot_search: 'عمليات البحث الرائجة',
        search_history: 'سجلّ البحث',
        suggested_product: 'منتجات مقترحة',
        suggested_search: 'اقتراحات البحث',
    },
    nl: {
        search_delete: 'Verwijderen',
        site_nav_search: 'Zoek op Ecoflow.com',
        site_nav_search_recommend: 'Aanbevelingen',
        site_nav_search_recommend_bundle: 'Bundels aanbevelen',
        search_empty: 'Geen inhoud～',
        hot_search: 'Populaire zoektermen',
        search_history: 'Zoekgeschiedenis',
        suggested_product: 'Voorgesteld product',
        suggested_search: 'Voorgestelde zoekopdracht',
    },
};
const formatOffText = (value: number, locale: string) => {
    const localeText = {
        us: `${value}% OFF`,
        de: `${value}% Rabatt`,
        fr: `${value}% OFF`,
        it: `Sconto ${value}%`,
        es: `Descuento${value}%`,
        jp: `${value}%OFF`,
        kr: `${value}% 할인`,
        br: `Descuento${value}%`,
        mx: `Descuento${value}%`,
        sa: `خصم  ${value}%`,
    };
    return localeText[locale as keyof typeof localeText] || localeText.us;
};

export { i18nText, formatOffText };
